import {createTheme, Theme, ThemeOptions} from "@mui/material";
// Dark Theme
const theme: Theme = createTheme({
    components: {
        typography: {
            fontFamily: "'Work Sans', system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial",
            h1: { fontFamily: "'Borna', 'Work Sans'", fontWeight: 500 },
            h2: { fontFamily: "'Borna', 'Work Sans'", fontWeight: 500 },
            h3: { fontFamily: "'Borna', 'Work Sans'", fontWeight: 500 },
            h4: { fontFamily: "'Borna', 'Work Sans'", fontWeight: 500 },
            h5: { fontFamily: "'Borna', 'Work Sans'", fontWeight: 500 },
            h6: { fontFamily: "'Borna', 'Work Sans'", fontWeight: 500 },
        },
        MuiButton: {
            styleOverrides: {
                root: ({ ownerState }) => ({
                    ...(ownerState.variant === 'contained' &&
                        ownerState.color === 'primary' && {
                            backgroundColor: '#202020',
                            color: '#fff',
                        }),
                }),
                contained:{backgroundColor: 'green'}
            },
        },
    },
} as ThemeOptions);

export default theme;
